import * as React from 'react';

const SvgCheckMark = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='19'
    height='15'
    viewBox='0 0 19 15'
    fill='none'
    className={props.className}
  >
    <path
      d='M7.19149 14.8167L0.507324 8.1325V4.94917L7.19982 11.6417L18.4998 0.5L18.554 3.55417L7.19149 14.8167Z'
      fill='#52981D'
    />
  </svg>
);

export default SvgCheckMark;
